<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="LanguageManage_Table1" :fields="fields" :title="table_title.title1" :table_height_adjust="0"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false"
        :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label" :query_button_label="query_lable" :specialExport="true"
        @state_change="state_change" :show_toolbar_button="[1, 1, 0, 0, 1]" @specialExport="tool_invoke"
        @on_cell_button_click="on_cell_button_click" @on_query="on_query" tableref="026d064a04ff40ca8cfd1568c982dd09">
        <template #query>
          {{$t('common.categroy')}}：<el-select v-model="searcType" filterable clearable placeholder="Search..." style="width: 150px">
            <el-option v-for="item in langType" :key="item.key" :label="item.key+'-'+item.label" :value="item.key"></el-option>
          </el-select>
          {{$t('common.language')}}: <el-select class="ml-2" v-model="searchLangCode" filterable clearable placeholder="Search"
            style="width: 150px">
            <el-option v-for="item in langList" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
          {{$t('common.name')}}：<el-input size="small" v-model="langName" style="width: 200px" clearable></el-input>
        </template>
        <template #toolbar>
          <el-button type="info" plain @click="editeObj('new')" class="ml-2 iconfont icon-add-new" size="mini"> {{$t("common.new")}}
          </el-button>
          <el-select class="ml-2" v-model="motherLangCode" filterable clearable :placeholder="$t('common.mother_lang')" style="width: 150px"
            @change="MotherLangChanged">
            <el-option v-for="item in langList" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>
        </template>
        <template #specialExport>
          <el-dropdown-item command="specialExport" divided>{{$t("common.export")}}</el-dropdown-item>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="$t('common.'+modal_title)" @saveData="saveData">
      <template #modal_content>
        <el-form :model="itemInfo" ref="dataForm" label-width="100px" style="height:200px">
          <el-col :span="12">
            <el-form-item :label="$t('common.categroy')" prop="type">
              <el-select v-model="itemInfo.type" filterable clearable placeholder="Search..." style="width: 100%">
                <el-option v-for="(item,index) in langType" :key="index" :label="item.key+'-'+item.label" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('common.language')" prop="lang">
              <el-select v-model="itemInfo.lang" filterable clearable placeholder="Search..." style="width: 100%">
                <el-option v-for="(item,index) in langList" :key="index" :label="item.label" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('common.name')" prop="code">
              <el-input v-model="itemInfo.code"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('common.Language_text')" prop="text">
              <el-input type="textarea" v-model="itemInfo.text"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import FileSaver from "file-saver"
import BaseContainer from "../components/BaseContainer";
import TableMain from "../components/table/TableMain";
import BaseModal from "../components/modals/baseModal";
import TestQueryPanel from "../components/base/TestQueryPanel";
import * as api from "../../shared/api";
import SplitContainer2 from "../components/container/SplitContainer2";
import * as SystemSettingController from "../../controllers/system/SystemSettingController";

export default {
  name: "PropertyManage",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer2,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_language",
      },
      modal_title: "new",
      fields: [],
      langType: [
        { key: "nav", label: "菜单" },
        { key: "login", label: "登录" },
        { key: "tab", label: "标签页" },
        { key: "table", label: "表格" },
        { key: "table_column", label: "字段" },
        { key: "common", label: "公共" },
        { key: "dialog", label: "弹出框" },
        { key: "notify", label: "提示" },
        { key: "modal", label: "确认框" },
        { key: "email_template", label: "邮件模板" }
      ],
      langList: [
        { key: "zh-CN", label: "中文(Chinese)" },
        { key: "en", label: "英语(English)" },
      ],
      itemInfo: {
        id: "",
        type: "",
        code: "",
        lang: "",
        mother_text: "",
        text: "",
        is_valid: true
      },
      langName: "",
      motherLangCode: "zh-CN",
      searchLangCode: "zh-CN",
      searcType: "nav",
      his_lang_list: []
    };
  },
  created() {
    this.fields = [
      {
        key: "id",
        label: "编号",
        type: "button",
        button: { type: "text" },
        thStyle: { width: "60px" }
      },
      {
        key: "type",
        label: "类别",
        sortable: true
      },
      {
        key: "code",
        label: "名称",
        sortable: true
      },
      {
        key: "lang",
        label: "语言编码",
        sortable: true
      },
      {
        key: "mother_text",
        label: "母语",
        sortable: true
      },
      {
        key: "text",
        label: "其他语言",
        sortable: true
      },
      {
        key: "is_valid",
        label: "状态",
        type: "boolean"
      }
    ]
  },
  methods: {
    //#region 查询
    ///获取权限列表
    async on_query(set_data) {
      let _this = this;
      let p = { is_deleted: 0 }, f = _.filter(this.fields, (t) => {
        return t.key != "mother_text"
      });
      if (this.searcType != "") {
        p.type = { "=": this.searcType }
      }
      if (this.langName != "") {
        p.code = { like: "%" + this.langName + "%" }
      }

      let _result = await SystemSettingController.methods.GetDataLanguage(p, f);
      if (_result && _result.length > 0) {
        this.his_lang_list = _.orderBy(_result[0], ["id"], ["asc"]);
        let lang_list = _.orderBy(_result[0], ["id"], ["asc"]);
        _.each(lang_list, (t) => {
          let m = _.find(lang_list, { lang: this.motherLangCode, code: t.code, type: t.type })
          if (m) {
            t.mother_text = m.text
          }
        })
        if (this.searchLangCode != "") {
          lang_list = _.filter(lang_list, { lang: this.searchLangCode })
        }
        set_data(lang_list);
      } else {
        set_data([]);
      }
    },
    ///cell click
    async on_cell_button_click(data) {
      for (var k in data.item) {
        if (this.itemInfo.hasOwnProperty(k)) {
          this.itemInfo[k] = data.item[k]
        }
      }
      this.editeObj("edit");
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    editeObj(code) {
      let title = "";
      switch (code) {
        case "new":
          title = "new";
          this.itemInfo = {
            id: "",
            type: "",
            code: "",
            lang: "",
            mother_text: "",
            text: "",
            is_valid: true
          }
          break;
        case "edit":
          title = "edite";
          break;
      }
      this.modal_title = title;
      this.$refs.bvModal.show();
    },
    ///新增修改
    async saveData(cb) {
      let msg = "";
      let f = _.filter(this.fields, (t) => {
        return t.key != "mother_text"
      });
      let t = _.cloneDeep(this.itemInfo)
      if (t.type == "") {
        msg = "请选择类别!"
      }
      if (t.lang == "") {
        msg = "请选择语言!";
      }
      if (t.code == "") {
        msg = "请输入名称!";
      }
      if (t.text == "") {
        msg = "请输入语言文本!";
      }
      if (msg != "") {
        this.msgToasts(msg, "info");
        cb(null);
        return
      }
      delete t.mother_text;
      let action_state = t.id == "" ? "add" : "edit";
      let _result = await SystemSettingController.methods.LanguageSaveData([t], f, action_state);
      if (_result && _result.length > 0) {
        let m = _.cloneDeep(_result[0][0])
        if (this.motherLangCode == m.lang) {
          m.mother_text = m.text
        }
        if (t.id == "") {
          this.$refs.LanguageManage_Table1.InsertItems(m)
        }
        else {
          this.$refs.LanguageManage_Table1.UpdateItems({ id: m.id }, m)
        }
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(null);
        this.$refs.bvModal.cancel();
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info");
        cb(false)
      }
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        cb(false);
        return;
      }
      let is_ok = await this.msgModal("确定要继续吗？");
      if (!is_ok) {
        cb(false);
        return
      }
      let f = _.filter(this.fields, (t) => {
        return t.key != "mother_text"
      });

      let _result = null;
      if (data.state == "valid" || data.state == "invalid") {
        let dt = _.map(data.selected_items, (t) => {
          return { id: t.id, is_valid: data.state == "valid" }
        })
        _result = await SystemSettingController.methods.LanguageSaveData(dt, f, "edit");
      }
      else {
        let dt = _.map(data.selected_items, (t) => {
          return { id: t.id }
        })
        _result = await SystemSettingController.methods.LanguageRemoveData(dt);
      }

      if (_result && _result.length > 0) {
        _.each(_result[0], (t) => {
          let m = _.cloneDeep(t)
          this.$refs.LanguageManage_Table1.UpdateItems({ id: m.id }, m)
        })
        this.msgToasts(this.$t("notify.action_successfully"), "success");
        cb(true);
        this.$refs.bvModal.cancel();
      } else {
        ///失败
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error");
        cb(false);
      }
    },
    MotherLangChanged() {
      if (this.motherLangCode != "") {
        let dt = this.$refs.LanguageManage_Table1.my_data;
        _.each(dt, (t) => {
          let m = _.find(this.his_lang_list, { lang: this.motherLangCode, code: t.code, type: t.type })
          if (m) {
            t.mother_text = m.text
          }
        })
      }
    },
    //#endregion

    //#region 打印导出
    tool_invoke() {
      let data = this.$refs.LanguageManage_Table1.my_data;
      _.each(this.langList, (t) => {
        let lang_group_dt = _.groupBy(_.filter(data, { lang: t.key }), "type");
        for (var k in lang_group_dt) {
          let item = {}
          _.each(lang_group_dt[k], (m) => {
            item[m.code] = m.text
          })
          lang_group_dt[k] = item
        }
        const blob = new Blob([JSON.stringify(lang_group_dt)], { type: '' })
        FileSaver.saveAs(blob, t.key + '.json')
      })
    },
    //#endregion
  },
};
</script>
